export default {
    getDetail:  state => id => state.userList.find(v => v.id === id)
}
